import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { createPortal } from 'react-dom';
import { cn } from '../../../lib/cn';
import { useFloatingAreaContext } from './context';
function useIsClient() {
    return React.useSyncExternalStore(() => () => { }, () => true, () => false);
}
/**
 * 페이지 위에 뜨는 비차단 플로팅 컨테이너(기본: 우측 하단).
 * `document.body`로 포탈해 레이아웃 `overflow`에 잘리지 않게 한다.
 * 래퍼는 `pointer-events-none`, 슬롯은 `pointer-events-auto`라 빈 영역 클릭을 가로채지 않는다.
 */
export function FloatingAreaHost({ className, ...props }) {
    const { setTarget } = useFloatingAreaContext();
    const isClient = useIsClient();
    const setPageEl = React.useCallback((el) => {
        setTarget('page', el);
    }, [setTarget]);
    const setPersistentEl = React.useCallback((el) => {
        setTarget('persistent', el);
    }, [setTarget]);
    if (!isClient) {
        return null;
    }
    return createPortal(_jsxs("div", { "data-slot": "floating-area-host", className: cn('pointer-events-none fixed right-0 bottom-0 z-40 flex flex-col items-end space-y-2 p-4 pb-[max(1rem,var(--lc-floating-area-inset-bottom,env(safe-area-inset-bottom)))] pr-[max(1rem,env(safe-area-inset-right))]', className), ...props, children: [_jsx("div", { ref: setPageEl, "data-slot": "floating-area-page", className: "pointer-events-auto flex flex-col items-end space-y-2 empty:hidden" }), _jsx("div", { ref: setPersistentEl, "data-slot": "floating-area-persistent", className: "pointer-events-auto flex flex-col items-end space-y-2 empty:hidden" })] }), document.body);
}
//# sourceMappingURL=FloatingAreaHost.js.map